import '@styles/views/aboutksj.less';
import AppFooter from '@components/app/appFooter';

const AboutKsj = () => {
  /*  const part1List = [
    { name: '业务领域', logo: require('@images/about/01.png').default },
    { name: 'BIM咨询', logo: require('@images/about/02.png').default },
    { name: '施工管理', logo: require('@images/about/03.png').default },
    { name: 'BIM设计', logo: require('@images/about/04.png').default },
    { name: '二维软件', logo: require('@images/about/05.png').default },
  ]; */

  /* const part1ListJSX = part1List.map((item) => {
    return (
      <div key={item.name} className={'item'}>
        <div className={'icon'}>
          <img src={item.logo} alt="" />
        </div>

        <span>{item.name}</span>
      </div>
    );
  }); */

  /* const part2List = [
    {
      name: '设计大师',
      desc: 'CivilStation Designer',
      logo: require('@images/about/06.png').default,
    },
    {
      name: '建造大师',
      desc: 'CivilStation Construction',
      logo: require('@images/about/07.png').default,
    },
    { name: '桥梁大师', desc: '2021', logo: require('@images/about/08.png').default },
    { name: 'BIM视窗', desc: 'BIM Windows', logo: require('@images/about/09.png').default },
  ]; */

  /* const part2ListJSX = part2List.map((item) => {
    return (
      <div key={item.name} className={'item'}>
        <img src={item.logo} alt="" />

        <div>
          <span className={'name'}>{item.name}</span>
          <span className={'desc'}>{item.desc}</span>
        </div>
      </div>
    );
  }); */

  return (
    <div className={'about-page'}>
      <div className={'introduce'}>
        <div className={'content-title'}>
          <br />
          <span className={'text'}>公司介绍</span>
        </div>

        <div className={'content'}>
          <div className={'part1'}>
            <p>
              北京跨世纪软件技术有限公司（简称跨世纪
              <span className={'w'}>
                <span className={'r'}>®</span>
              </span>
              /KSJ）是专注基础设施领域 CAD/BIM/GIS
              软件研发与技术咨询的高新技术企业，是知名软件“桥梁大师”、“路线大师”的原创公司。公司总部设立于北京，分别在长沙、成都、武汉等地设有分公司。
            </p>
            {/* <div className={'icon-list'}>{part1ListJSX}</div> */}
          </div>

          <div className={'part2'}>
            <p>
              跨世纪
              <span className={'w'}>
                <span className={'r'}>®</span>
              </span>
              坚持创新，追求品质，经过二十余年的发展，核心业务涵盖工具软件、解决方案、技术研发、咨询服务等方向；合作伙伴遍布公路、铁路、市政、水利等多个行业的设计院、施工局及高校；主要产品具备自主知识产权，特别在
              BIM 设计、BIM
              施工、数字孪生等解决方案有着深厚技术积累，能够为用户提供专业产品与完备的研发服务。
            </p>
            {/* <div className={'icon-list'}>{part2ListJSX}</div> */}
          </div>

          <div className={'part3'}>
            <p>
              凭借创新性科技成果，跨世纪
              <span className={'w'}>
                <span className={'r'}>®</span>
              </span>
              获批成为国家高新技术企业、中关村高新技术企业、北京“专精特新”中小企业；先后入选中国公路学会、铁路
              BIM 联盟等专业领域的会员单位，并多次取得专项奖励。
            </p>
            {/* <img width={'100%'} src={require('@images/about/10.png').default} alt="" /> */}
          </div>

          <div className={'part4'}>
            <p>
              跨世纪
              <span className={'w'}>
                <span className={'r'}>®</span>
              </span>
              团队充满朝气、务实坦诚、精益求精，致力于用出色的技术和创新的理念发展“更快（K）、更实（S）、更精（J）”的产品与服务，助力基础设施行业的数字化转型，与用户实现共同成长！
            </p>

            {/* <div className={'icon-list'}>
              <img width={'100%'} src={require('@images/about/11.png').default} alt="" />
              <img width={'100%'} src={require('@images/about/12.png').default} alt="" />
              <img width={'100%'} src={require('@images/about/13.png').default} alt="" />
            </div> */}
          </div>
          <div className={'part5'}>
            <p>
              跨世纪
              <span className={'w'}>
                <span className={'r'}>®</span>
              </span>
              （KSJ）是 Bentley
              软件公司的白金代理商，为基础设施行业（桥梁、公路、铁路、市政等）的专业用户提供 BIM
              全面解决方案。
            </p>
          </div>
        </div>
      </div>

      <AppFooter />
    </div>
  );
};

export default AboutKsj;
